import { render, staticRenderFns } from "./baseList.vue?vue&type=template&id=2b40aab3&scoped=true"
import script from "./baseList.vue?vue&type=script&lang=ts"
export * from "./baseList.vue?vue&type=script&lang=ts"
import style0 from "./baseList.vue?vue&type=style&index=0&id=2b40aab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40aab3",
  null
  
)

export default component.exports